import { ChainWalletBase } from '../../bases';
export class ChainWalletCosmiframe extends ChainWalletBase {
    constructor(walletInfo, chainInfo) {
        super(walletInfo, chainInfo);
    }
}
